module.exports = __webpack_public_path__ + "static/map-cb3d64149c26990aff877a1af66bbd8c.jpg";